module.exports = __webpack_public_path__ + "img/trippify.5e672aec.png";